module.exports = __webpack_public_path__ + "about-us-b998e096/upload-a3282b78793010826cfdc2dc9eb81607.svg";